export function Footer({ variant = "full" }) {
  const minimal = variant === "minimal";
  return (
    <footer
      data-testid="footer"
      className={minimal ? "mt-16 pb-10 pt-4" : "mt-20 border-t border-teal/25 pb-12 pt-8"}
    >
      {!minimal && (
        <p className="font-display text-lg font-bold text-ink" data-testid="footer-brand">
          MindRegen
        </p>
      )}
      <p className={`flex flex-wrap gap-x-5 gap-y-2 text-[13px] ${minimal ? "" : "mt-4"}`}>
        <a
          href="/confidentialitate"
          data-testid="footer-privacy-link"
          className="text-teal underline-offset-4 transition-colors duration-200 hover:underline"
        >
          Politică de confidențialitate
        </a>
        <a
          href="/termeni"
          data-testid="footer-terms-link"
          className="text-teal underline-offset-4 transition-colors duration-200 hover:underline"
        >
          Termeni
        </a>
        <a
          href="/contact"
          data-testid="footer-contact-link"
          className="text-teal underline-offset-4 transition-colors duration-200 hover:underline"
        >
          Contact
        </a>
      </p>
    </footer>
  );
}
